import type {ComponentProps} from 'react';
import {useTranslation} from 'react-i18next';
import {PawPrint, Smile, UserRound} from 'lucide-react';
import {FORM_NAMES} from '../constants';
import {WelcomeGuestCountNote, WelcomeSteps} from '../WelcomeSteps';
import {NumberOfGuestsForm} from './NumberOfGuestsForm';

const COUNTER_ICONS = {
  [FORM_NAMES.numberOfGuests]: <UserRound size={18} />,
  [FORM_NAMES.middle]: <UserRound size={18} />,
  [FORM_NAMES.senior]: <UserRound size={18} />,
  [FORM_NAMES.junior]: <Smile size={18} />,
  [FORM_NAMES.numberOfPets]: <PawPrint size={18} />,
};

type Props = Omit<
  ComponentProps<typeof NumberOfGuestsForm>,
  'icons' | 'submitLabel' | 'renderHeader' | 'renderBeforeSubmit' | 'petsSubtitle'
>;

function WhosComingForm(props: Props) {
  const {t} = useTranslation();

  return (
    <NumberOfGuestsForm
      {...props}
      icons={COUNTER_ICONS}
      petsSubtitle={t('auth.pets_fee_hint')}
      submitLabel={totalGuests => t('confirm_n_guests', {count: totalGuests})}
      renderHeader={totalGuests => <WelcomeSteps totalGuests={totalGuests} />}
      renderBeforeSubmit={totalGuests => (
        <WelcomeGuestCountNote
          bookedGuests={props.guestGroup?.known_number_of_guests}
          totalGuests={totalGuests}
        />
      )}
    />
  );
}

export {WhosComingForm};
